import React, { useState, useRef, useEffect } from 'react';
import MobileWelcome from './MobileWelcome';
import MobileOnboarding from './MobileOnboarding';
import MobileTerms from './MobileTerms';
import { useGoogleLogin } from '@react-oauth/google';

function MHJLogo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="216 265 667 510"
      style={{ filter: 'drop-shadow(0 4px 8px rgba(90,60,180,0.18))' }}
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="mhjGrad" gradientUnits="userSpaceOnUse" x1="216" y1="0" x2="883" y2="0">
          <stop offset="0%" stopColor="#0a3fe0"/>
          <stop offset="30%" stopColor="#3a54da"/>
          <stop offset="60%" stopColor="#a42ea3"/>
          <stop offset="100%" stopColor="#e2368c"/>
        </linearGradient>
      </defs>
      <path fill="url(#mhjGrad)" fillRule="evenodd"
        d="M 496.00,344.00 C 495.10,340.80 481.87,333.69 479.00,332.00 C 476.13,330.31 454.79,319.09 450.00,317.00 C 445.21,314.91 421.08,306.25 417.00,305.00 C 412.92,303.75 394.81,299.69 391.00,299.00 C 387.19,298.31 370.86,296.21 367.00,296.00 C 363.14,295.79 336.07,295.92 335.00,296.00 C 333.93,296.08 329.80,298.36 329.00,299.00 C 328.20,299.64 325.48,303.11 325.00,304.00 C 324.52,304.89 323.01,308.99 323.00,310.00 C 322.99,311.01 323.00,478.77 323.00,479.00 C 323.00,479.23 323.77,479.99 324.00,480.00 C 324.23,480.01 349.77,480.01 350.00,480.00 C 350.23,479.99 351.00,479.23 351.00,479.00 C 351.00,478.77 350.99,328.68 351.00,328.00 C 351.01,327.32 353.33,325.11 354.00,325.00 C 354.67,324.89 366.61,324.80 369.00,325.00 C 371.39,325.20 386.69,327.26 390.00,328.00 C 393.31,328.74 417.84,335.17 423.00,337.00 C 428.16,338.83 451.85,349.45 455.00,351.00 C 458.15,352.55 471.68,360.52 474.00,362.00 C 476.32,363.48 487.69,371.82 488.00,372.00 C 488.31,372.18 489.90,371.34 490.00,371.00 C 490.10,370.66 496.90,347.20 496.00,344.00 Z M 263.00,361.00 C 262.36,403.88 261.64,452.12 261.00,495.00 C 248.20,496.60 233.80,498.40 221.00,500.00 C 221.00,507.36 221.00,515.64 221.00,523.00 C 282.12,523.96 402.75,528.01 412.00,526.00 C 421.25,523.99 432.40,491.32 442.00,475.00 C 454.16,504.12 467.84,536.88 480.00,566.00 C 486.08,562.48 497.98,558.36 499.00,555.00 C 500.02,551.64 524.84,434.64 537.00,378.00 C 550.12,454.48 564.88,540.52 578.00,617.00 C 584.40,614.12 596.77,611.29 598.00,608.00 C 599.23,604.71 621.12,516.20 632.00,473.00 C 638.40,480.36 647.12,495.96 652.00,496.00 C 656.88,496.04 729.31,473.85 741.00,474.00 C 752.69,474.15 806.38,486.88 810.00,498.00 C 813.62,509.12 808.64,621.76 808.00,680.00 C 774.08,679.68 718.73,676.21 702.00,679.00 C 685.27,681.79 623.12,704.84 586.00,717.00 C 609.36,700.04 645.77,669.77 659.00,664.00 C 672.23,658.23 762.43,650.04 774.00,635.00 C 785.57,619.96 776.84,516.38 776.00,512.00 C 775.16,507.62 757.64,507.24 749.00,505.00 C 748.36,539.24 758.17,599.02 747.00,612.00 C 735.83,624.98 640.37,640.49 626.00,648.00 C 611.63,655.51 574.32,693.56 550.00,715.00 C 523.44,692.60 482.44,652.96 467.00,645.00 C 451.56,637.04 362.45,621.36 354.00,614.00 C 345.55,606.64 351.96,566.40 351.00,544.00 C 342.04,544.00 331.96,544.00 323.00,544.00 C 325.24,574.72 319.20,629.02 330.00,640.00 C 340.80,650.98 429.15,659.39 442.00,665.00 C 454.85,670.61 488.92,701.72 511.00,719.00 C 476.44,706.52 420.66,683.05 403.00,680.00 C 385.34,676.95 326.84,680.68 291.00,681.00 C 290.36,637.16 289.64,587.84 289.00,544.00 C 280.36,543.68 270.64,543.32 262.00,543.00 C 263.60,596.12 265.40,655.88 267.00,709.00 C 315.00,709.96 393.59,706.69 417.00,712.00 C 440.41,717.31 537.67,774.76 558.00,775.00 C 578.33,775.24 650.29,719.96 670.00,715.00 C 689.71,710.04 782.88,708.20 836.00,705.00 C 836.96,638.76 838.04,564.24 839.00,498.00 C 849.88,497.36 870.00,497.36 873.00,496.00 C 876.00,494.64 879.80,483.76 883.00,478.00 C 844.60,470.64 801.40,462.36 763.00,455.00 C 788.60,424.60 839.37,366.40 843.00,360.00 C 846.63,353.60 845.19,320.33 843.00,314.00 C 840.81,307.67 821.85,285.26 816.00,282.00 C 810.15,278.74 779.30,274.03 773.00,275.00 C 766.70,275.97 744.37,294.08 738.00,294.00 C 731.63,293.92 697.15,273.65 689.00,274.00 C 680.85,274.35 647.75,294.44 644.00,298.00 C 640.25,301.56 632.55,322.86 632.00,328.00 C 631.45,333.14 633.97,359.04 637.00,364.00 C 640.03,368.96 680.52,416.36 701.00,441.00 C 708.36,435.56 716.64,429.44 724.00,424.00 C 704.16,400.64 664.82,357.35 662.00,351.00 C 659.18,344.65 669.95,312.59 673.00,309.00 C 676.05,305.41 697.58,302.38 702.00,304.00 C 706.42,305.62 728.52,324.40 741.00,334.00 C 750.60,325.04 767.63,307.87 771.00,306.00 C 774.37,304.13 791.31,302.88 795.00,304.00 C 798.69,305.12 812.11,315.62 814.00,319.00 C 815.89,322.38 819.54,341.08 818.00,345.00 C 816.46,348.92 791.53,386.35 785.00,393.00 C 778.47,399.65 708.37,458.67 703.00,462.00 C 697.63,465.33 669.54,471.03 664.00,468.00 C 658.46,464.97 641.31,429.36 639.00,427.00 C 636.69,424.64 625.40,423.60 619.00,422.00 C 609.08,454.96 597.92,492.04 588.00,525.00 C 574.88,444.04 560.12,352.96 547.00,272.00 C 539.64,275.20 525.13,278.15 524.00,282.00 C 522.87,285.85 494.76,427.52 481.00,496.00 C 473.32,474.56 458.64,431.86 457.00,429.00 C 455.36,426.14 444.08,423.56 438.00,421.00 C 425.84,445.32 412.08,490.76 400.00,497.00 C 387.92,503.24 325.88,497.00 291.00,497.00 C 290.36,461.48 288.64,388.77 289.00,386.00 C 289.36,383.23 304.62,384.43 306.00,382.00 C 307.38,379.57 306.00,364.32 306.00,356.00 C 292.24,357.60 276.76,359.40 263.00,361.00 Z"
      />
    </svg>
  );
}

export default function MobileAuth({ onLogin }) {
  const [screen, setScreen] = useState('welcome');
  const [prevScreen, setPrevScreen] = useState('');
  const [onboardingStartScreen, setOnboardingStartScreen] = useState(1);
  const [registeredPhone, setRegisteredPhone] = useState('');
  const [patientUID, setPatientUID] = useState('');
  const [googleUser, setGoogleUser] = useState(null);

  const handleGoogleLogin = async (userInfo) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Auth/google-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: userInfo.email, googleId: userInfo.sub })
      });
      const data = await response.json();
      if (response.ok) { onLogin(data); return; }
    } catch { }
    setGoogleUser(userInfo);
    setScreen('register-type');
    setPrevScreen('onboarding');
  };

  if (screen === 'terms') return (
    <MobileTerms onAccept={() => setScreen('register-type')} onDecline={() => setScreen('welcome')} />
  );

  if (screen === 'welcome') return (
    <MobileWelcome onGetStarted={() => setScreen('onboarding')} onLogin={() => setScreen('login')} />
  );

  if (screen === 'onboarding') return (
    <MobileOnboarding
      startScreen={onboardingStartScreen}
      onFinish={() => { setOnboardingStartScreen(1); setPrevScreen('onboarding'); setScreen('terms'); }}
      onSignIn={() => { setOnboardingStartScreen(1); setPrevScreen('onboarding'); setScreen('login'); }}
      onBack={() => { setOnboardingStartScreen(1); setScreen('welcome'); }}
    />
  );

  if (screen === 'login') return (
    <LoginForm onLogin={onLogin} onRegister={() => { setPrevScreen('login'); setScreen('terms'); }}
      onGoogleLogin={handleGoogleLogin} onBack={() => setScreen('welcome')} />
  );

  if (screen === 'register-type') return (
    <div className="relative w-full min-h-screen bg-white overflow-hidden flex flex-col"
      style={{ fontFamily: 'Inter, sans-serif', maxWidth: '430px', margin: '0 auto' }}>

      {/* Background */}
      <div className="absolute inset-0 z-0" style={{ background: 'linear-gradient(180deg, #f6f5ff 0%, #ffffff 45%, #f4f3fd 100%)' }} />
      <div className="absolute z-0" style={{ top: '-60px', right: '-120px', width: '380px', height: '380px', borderRadius: '999px', background: 'radial-gradient(circle, rgba(120,110,230,0.10) 0%, rgba(255,255,255,0) 70%)' }} />
      <div className="absolute z-0" style={{ bottom: '-140px', left: '-120px', width: '380px', height: '380px', borderRadius: '999px', background: 'radial-gradient(circle, rgba(150,140,235,0.14) 0%, rgba(255,255,255,0) 70%)' }} />
      <div className="absolute z-0" style={{ top: '70px', right: '30px', width: '90px', height: '110px', backgroundImage: 'radial-gradient(#c9cce2 1.5px, transparent 1.5px)', backgroundSize: '16px 16px', opacity: 0.6 }} />
      <span className="material-symbols-outlined absolute z-0" style={{ top: '320px', left: '30px', fontSize: '26px', color: '#d8daf0' }}>add</span>
      <span className="material-symbols-outlined absolute z-0" style={{ top: '380px', right: '40px', fontSize: '22px', color: '#d8daf0' }}>add</span>

      {/* Back button */}
      <button onClick={() => { if (prevScreen === 'onboarding') { setOnboardingStartScreen(3); setScreen('onboarding'); } else setScreen('login'); }}
        className="absolute top-8 left-5 z-50 w-11 h-11 rounded-full flex items-center justify-center bg-white shadow-md active:scale-95 transition-all">
        <span className="material-symbols-outlined text-[#1a1c2e]" style={{ fontSize: '22px' }}>arrow_back</span>
      </button>

      {/* Header — Big Logo */}
      <div className="relative z-10 w-full flex flex-col items-center pt-16 px-8">
        <MHJLogo size={90} />
        <h1 className="font-black text-[26px] text-[#1a1c2e] text-center leading-tight mt-2">My Health</h1>
        <h1 className="font-black text-[26px] text-center leading-tight mb-1" style={{
          background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 55%, #5a4bdc 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
        }}>Journal</h1>
        <h2 className="text-xl font-black text-[#1a1c2e] text-center mt-2 mb-1">Create Account</h2>
        <p className="text-gray-500 text-[15px] font-medium text-center mb-6">Select your account type</p>
      </div>

      {/* Account type cards */}
      <div className="relative z-10 flex-1 w-full px-6 flex flex-col gap-5">
        {[
          { type: 'patient', icon: 'person', label: 'Patient', desc: 'Manage your health records and medications', accent: '#5a3fd6', iconBg: '#ece6fb' },
          { type: 'doctor', icon: 'medical_services', label: 'Doctor', desc: 'Access patient records and manage prescriptions', accent: '#3b55f0', iconBg: '#e6ebff' },
          { type: 'provider', icon: 'science', label: 'Provider', desc: 'Upload reports and manage lab results', accent: '#0f9488', iconBg: '#e2f7f3' },
        ].map(item => (
          <button key={item.type} onClick={() => setScreen(`instructions-${item.type}`)}
            className="w-full bg-white rounded-2xl p-5 flex items-center gap-4 active:scale-95 transition-all text-left"
            style={{ borderLeft: `4px solid ${item.accent}`, boxShadow: '0 8px 24px rgba(90,63,214,0.10)' }}>
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center shrink-0" style={{ background: item.iconBg }}>
              <span className="material-symbols-outlined" style={{ fontSize: '30px', color: item.accent, fontVariationSettings: '"FILL" 1' }}>{item.icon}</span>
            </div>
            <div className="flex-1">
              <p className="font-extrabold text-lg mb-0.5" style={{ color: item.accent }}>{item.label}</p>
              <p className="text-gray-500 text-[14px] leading-snug">{item.desc}</p>
            </div>
            <div className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ background: item.iconBg }}>
              <span className="material-symbols-outlined" style={{ fontSize: '20px', color: item.accent }}>chevron_right</span>
            </div>
          </button>
        ))}
        <div className="mt-4 mb-10 text-center">
          <p className="text-[15px] text-gray-500">Already have an account?{' '}
            <button onClick={() => { setPrevScreen('register-type'); setScreen('login'); }} className="font-extrabold" style={{ color: '#3446e0' }}>Sign In</button>
          </p>
        </div>
      </div>
    </div>
  );

  if (screen === 'instructions-patient') return (
    <InstructionsScreen role="patient" onBack={() => setScreen('register-type')}
      onGoogle={(userInfo) => { setGoogleUser(userInfo); setScreen('register-patient'); }}
      onManual={() => { setGoogleUser(null); setScreen('register-patient'); }} />
  );

  if (screen === 'instructions-doctor') return (
    <InstructionsScreen role="doctor" onBack={() => setScreen('register-type')}
      onGoogle={(userInfo) => { setGoogleUser(userInfo); setScreen('register-doctor'); }}
      onManual={() => { setGoogleUser(null); setScreen('register-doctor'); }} />
  );

  if (screen === 'instructions-provider') return (
    <InstructionsScreen role="provider" onBack={() => setScreen('register-type')}
      onGoogle={(userInfo) => { setGoogleUser(userInfo); setScreen('register-provider'); }}
      onManual={() => { setGoogleUser(null); setScreen('register-provider'); }} />
  );

  if (screen === 'register-patient') return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <TopBar onBack={() => setScreen('instructions-patient')} />
      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <RegHeader icon="person" role="Patient Registration" title="Create your account" subtitle="Fill in your details to get started" />
        <PatientRegForm googleUser={googleUser}
          onOTP={(phone) => { setRegisteredPhone(phone); setScreen('otp-verify'); }}
          onSignIn={() => { setPrevScreen('register-patient'); setScreen('login'); }} />
      </div>
    </div>
  );

  if (screen === 'otp-verify') return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <TopBar onBack={() => setScreen('register-patient')} />
      <div className="flex-1 px-6 py-8 flex flex-col items-center justify-center">
        <OTPScreen phone={registeredPhone} onVerified={(uid) => { setPatientUID(uid); setScreen('patient-success'); }} />
      </div>
    </div>
  );

  if (screen === 'patient-success') return (
    <PatientSuccessScreen uid={patientUID} onLogin={() => { setPrevScreen(''); setScreen('login'); }} />
  );

  if (screen === 'register-doctor') return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <TopBar onBack={() => setScreen('instructions-doctor')} />
      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <RegHeader icon="medical_services" role="Doctor Registration" title="Create your account" subtitle="Fill in your professional details" />
        <DoctorRegForm googleUser={googleUser} onSubmitted={() => setScreen('doctor-pending')}
          onSignIn={() => { setPrevScreen('register-doctor'); setScreen('login'); }} />
      </div>
    </div>
  );

  if (screen === 'doctor-pending') return (
    <PendingVerificationScreen role="Doctor" icon="medical_services" onLogin={() => { setPrevScreen(''); setScreen('login'); }} />
  );

  if (screen === 'register-provider') return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <TopBar onBack={() => setScreen('instructions-provider')} />
      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <RegHeader icon="local_hospital" role="Provider Registration" title="Create your account" subtitle="Register your lab or diagnostic center" />
        <ProviderRegForm googleUser={googleUser} onSubmitted={() => setScreen('provider-pending')}
          onSignIn={() => { setPrevScreen('register-provider'); setScreen('login'); }} />
      </div>
    </div>
  );

  if (screen === 'provider-pending') return (
    <PendingVerificationScreen role="Provider" icon="local_hospital" onLogin={() => { setPrevScreen(''); setScreen('login'); }} />
  );
}

// ═══════════════════════════════
// TOP BAR
// ═══════════════════════════════
function TopBar({ onBack }) {
  return (
    <div className="bg-white px-4 py-3 flex items-center gap-3 border-b border-gray-100 shrink-0">
      {onBack && (
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-full shrink-0">
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
      )}
      <div className="flex items-center gap-2">
        <MHJLogo size={28} />
        <span className="font-extrabold text-base" style={{
          background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
        }}>MyHealth Journal</span>
      </div>
    </div>
  );
}

// ═══════════════════════════════
// REG HEADER
// ═══════════════════════════════
function RegHeader({ icon, role, title, subtitle }) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-1">
        <div className="w-8 h-8 bg-[#003d9b]/10 rounded-lg flex items-center justify-center">
          <span className="material-symbols-outlined text-[#003d9b]" style={{ fontSize: '18px' }}>{icon}</span>
        </div>
        <span className="text-xs font-bold text-[#003d9b] uppercase tracking-wider">{role}</span>
      </div>
      <h2 className="text-2xl font-black text-[#191c1e]">{title}</h2>
      <p className="text-gray-500 text-sm mt-1">{subtitle}</p>
    </div>
  );
}

// ═══════════════════════════════
// INSTRUCTIONS SCREEN
// ═══════════════════════════════
function InstructionsScreen({ role, onBack, onGoogle, onManual }) {
  const [googleLoading, setGoogleLoading] = useState(false);

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setGoogleLoading(true);
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
        });
        const userInfo = await res.json();
        onGoogle(userInfo);
      } catch { alert('Google login failed.'); }
      setGoogleLoading(false);
    },
    onError: () => setGoogleLoading(false)
  });

  const instructions = {
    patient: {
      icon: 'person', bg: 'rgba(0,61,155,0.08)', badge: 'PATIENT REGISTRATION',
      title: 'Before you register',
      items: [
        { icon: 'badge', title: 'Why we need your Aadhaar', desc: 'Aadhaar is required for identity verification as per Indian healthcare regulations (ABDM). It ensures your health records are securely linked to you.', highlight: true },
        { icon: 'check_circle', title: 'Enter correct Aadhaar details', desc: 'Make sure your Aadhaar number matches your registered mobile number. Incorrect details will fail OTP verification.', highlight: false },
        { icon: 'lock', title: 'Your data is safe', desc: 'Your Aadhaar details are encrypted and never stored in plain text. We follow HIPAA & ABDM compliance standards.', highlight: false },
        { icon: 'smartphone', title: 'OTP Verification', desc: 'After registration, an OTP will be sent to verify your identity.', highlight: false },
      ]
    },
    doctor: {
      icon: 'medical_services', bg: 'rgba(0,61,155,0.08)', badge: 'DOCTOR REGISTRATION',
      title: 'Before you register',
      items: [
        { icon: 'verified', title: 'NMC Registration Number', desc: 'Your NMC (National Medical Commission) number is your unique medical license ID issued by the Government of India.', link: { text: 'What is NMC Number? →', url: 'https://en.wikipedia.org/wiki/National_Medical_Commission' }, highlight: true },
        { icon: 'upload_file', title: 'Upload NMC Certificate', desc: 'Upload a clear photo or PDF of your NMC registration certificate. This will be verified by our admin team within 30 minutes.', highlight: false },
        { icon: 'schedule', title: 'Verification Time', desc: "After submission, our team will verify your details. You'll receive an email once your account is approved.", highlight: false },
        { icon: 'lock', title: 'Data Security', desc: 'All your credentials are encrypted and stored securely. Only authorized admin can view verification documents.', highlight: false },
      ]
    },
    provider: {
      icon: 'local_hospital', bg: 'rgba(0,61,155,0.08)', badge: 'PROVIDER REGISTRATION',
      title: 'Before you register',
      items: [
        { icon: 'description', title: 'Registration Certificate', desc: 'Upload your lab or hospital registration certificate issued by the government or a regulatory body like NABL or NABH.', link: { text: 'What is this certificate? →', url: 'https://en.wikipedia.org/wiki/National_Accreditation_Board_for_Testing_and_Calibration_Laboratories' }, highlight: true },
        { icon: 'business', title: 'Organization Details', desc: 'Provide accurate organization name and registration number as it appears on your official certificate.', highlight: false },
        { icon: 'schedule', title: 'Verification Time', desc: "Provider accounts are verified within 30 minutes during business hours. You'll be notified via email once approved.", highlight: false },
        { icon: 'lock', title: 'Data Security', desc: 'All documents are encrypted and only accessible to our verification team.', highlight: false },
      ]
    }
  };

  const info = instructions[role];

  return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <TopBar onBack={onBack} />

      <div className="flex-1 px-6 py-6 overflow-y-auto">
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: info.bg }}>
              <span className="material-symbols-outlined text-[#003d9b]" style={{ fontSize: '18px' }}>{info.icon}</span>
            </div>
            <span className="text-xs font-bold text-[#003d9b] uppercase tracking-wider">{info.badge}</span>
          </div>
          <h2 className="text-2xl font-black text-[#191c1e]">{info.title}</h2>
          <p className="text-gray-500 text-sm mt-1">Please read before proceeding</p>
        </div>
        <div className="flex flex-col gap-3 mb-6">
          {info.items.map((item, i) => (
            <div key={i} className={`bg-white rounded-2xl p-4 border ${item.highlight ? 'border-[#003d9b]/30 bg-[#003d9b]/5' : 'border-gray-100'} shadow-sm`}>
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 ${item.highlight ? 'bg-[#003d9b]' : 'bg-gray-100'}`}>
                  <span className="material-symbols-outlined" style={{ fontSize: '18px', color: item.highlight ? 'white' : '#003d9b', fontVariationSettings: '"FILL" 1' }}>{item.icon}</span>
                </div>
                <div className="flex-1">
                  <p className="font-bold text-[#191c1e] text-sm mb-1">{item.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                  {item.link && (
                    <a href={item.link.url} target="_blank" rel="noopener noreferrer" className="text-[#003d9b] text-xs font-bold mt-1 inline-flex items-center gap-1">
                      {item.link.text}
                      <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>open_in_new</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
          <p className="text-sm font-bold text-[#191c1e] mb-4 text-center">How would you like to continue?</p>
          <button onClick={() => googleLogin()} disabled={googleLoading}
            className="w-full h-14 rounded-2xl flex items-center justify-center gap-3 border-2 border-gray-200 bg-white active:scale-95 transition-all mb-3 disabled:opacity-50"
            style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            {googleLoading ? <span className="text-gray-500 font-bold text-sm">⏳ Connecting to Google...</span> : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span className="font-bold text-gray-600 text-sm">Continue with Google</span>
              </>
            )}
          </button>
          <div className="flex items-center gap-3 mb-3">
            <div className="flex-1 h-px bg-gray-200"></div>
            <span className="text-gray-400 text-xs font-semibold">OR</span>
            <div className="flex-1 h-px bg-gray-200"></div>
          </div>
          <button onClick={onManual}
            className="w-full h-14 rounded-2xl text-white font-bold flex items-center justify-center gap-2 active:scale-95 transition-all"
            style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,63,214,0.3)' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>edit</span>
            Fill Details Manually
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════
// LOGIN FORM (MATCHED LOGO WITH MOBILEWELCOME)
// ═══════════════════════════════
function LoginForm({ onLogin, onRegister, onGoogleLogin, onBack }) {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [googleLoading, setGoogleLoading] = useState(false);

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setGoogleLoading(true);
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
        });
        const userInfo = await res.json();
        if (onGoogleLogin) onGoogleLogin(userInfo);
      } catch { alert('Google login failed.'); }
      setGoogleLoading(false);
    },
    onError: () => setGoogleLoading(false)
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: form.phone, password: form.password })
      });
      const data = await response.json();
      if (response.ok) onLogin(data);
      else setError(data.message || 'Invalid phone or password.');
    } catch { setError('Cannot connect to server.'); }
    setLoading(false);
  };

  return (
    <div className="relative w-full h-screen bg-white overflow-hidden flex flex-col"
      style={{ fontFamily: 'Inter, sans-serif', maxWidth: '430px', margin: '0 auto' }}>
      <div className="absolute inset-0 z-0" style={{ background: 'linear-gradient(180deg, #f6f5ff 0%, #ffffff 55%)' }} />
      <div className="absolute z-0" style={{ top: '-60px', right: '-120px', width: '380px', height: '380px', borderRadius: '999px', background: 'radial-gradient(circle, rgba(120,110,230,0.10) 0%, rgba(255,255,255,0) 70%)' }} />
      <div className="absolute z-0" style={{ bottom: '55%', left: '-140px', width: '320px', height: '320px', borderRadius: '999px', background: 'radial-gradient(circle, rgba(150,140,235,0.10) 0%, rgba(255,255,255,0) 70%)' }} />
      <div className="absolute z-0" style={{ top: '40px', right: '30px', width: '90px', height: '110px', backgroundImage: 'radial-gradient(#c9cce2 1.5px, transparent 1.5px)', backgroundSize: '16px 16px', opacity: 0.6 }} />
      <span className="material-symbols-outlined absolute z-0" style={{ top: '370px', left: '30px', fontSize: '26px', color: '#d8daf0' }}>add</span>
      
      {/* Back button */}
      <button onClick={onBack} className="absolute top-8 left-5 z-50 w-11 h-11 rounded-full flex items-center justify-center bg-white shadow-md active:scale-95 transition-all">
        <span className="material-symbols-outlined text-[#1a1c2e]" style={{ fontSize: '22px' }}>arrow_back</span>
      </button>

      {/* App Logo & Header */}
      <div className="relative z-10 w-full flex flex-col items-center pt-14 px-8">
        <MHJLogo size={90} />
        <h1 className="font-black text-[26px] text-[#1a1c2e] text-center leading-tight mt-2">My Health</h1>
        <h1 className="font-black text-[26px] text-center leading-tight mb-2" style={{
          background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 55%, #5a4bdc 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
        }}>Journal</h1>
        <h2 className="text-base font-extrabold text-[#1a1c2e] text-center mb-0.5">Welcome Back</h2>
        <p className="text-gray-500 text-sm font-medium text-center">Sign in to your health account</p>
      </div>

      <div className="relative z-10 w-full flex-1 bg-white rounded-t-[32px] px-6 pt-6 pb-4 flex flex-col mt-4 overflow-y-auto"
        style={{ boxShadow: '0 -10px 40px rgba(90,102,241,0.08)' }}>
        <button onClick={() => googleLogin()} disabled={googleLoading}
          className="w-full h-13 rounded-2xl border border-gray-200 flex items-center justify-center gap-3 font-bold text-[#1a1c2e] active:scale-95 transition-all mb-4 disabled:opacity-50 py-3">
          {googleLoading ? <span className="text-gray-500 font-bold text-sm">⏳ Connecting...</span> : (
            <>
              <svg width="20" height="20" viewBox="0 0 48 48">
                <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l6-6C34 5.5 29.3 3.5 24 3.5 12.7 3.5 3.5 12.7 3.5 24S12.7 44.5 24 44.5 44.5 35.3 44.5 24c0-1.2-.1-2.4-.3-3.5z"/>
                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.6 18.9 12.5 24 12.5c3 0 5.8 1.1 7.9 3l6-6C34 5.5 29.3 3.5 24 3.5c-7.5 0-14 4.2-17.7 10.2z"/>
                <path fill="#4CAF50" d="M24 44.5c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.2-7.2 2.2-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.9 40.2 16.4 44.5 24 44.5z"/>
                <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4.1 5.6l6.2 5.2C40.9 36 44.5 30.6 44.5 24c0-1.2-.1-2.4-.3-3.5z"/>
              </svg>
              <span className="font-bold text-gray-600 text-sm">Continue with Google</span>
            </>
          )}
        </button>
        <div className="flex items-center gap-3 mb-4">
          <span className="flex-1 h-[1px] bg-gray-200"></span>
          <span className="text-gray-400 text-sm font-semibold">OR</span>
          <span className="flex-1 h-[1px] bg-gray-200"></span>
        </div>
        {error && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm mb-3">{error}</div>}
        <label className="text-[#1a1c2e] font-bold text-sm mb-1.5 block">Phone Number</label>
        <div className="w-full h-13 rounded-2xl bg-gray-50 border border-gray-100 flex items-center px-3 gap-3 mb-4 py-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ background: '#e9e7ff' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '18px', color: '#5a3fd6', fontVariationSettings: '"FILL" 1' }}>call</span>
          </div>
          <input type="tel" placeholder="+91 98765 43210" value={form.phone}
            onChange={e => setForm({ ...form, phone: e.target.value })}
            className="bg-transparent outline-none border-none w-full text-base font-medium text-[#1a1c2e] placeholder-gray-400" />
        </div>
        <div className="flex items-center justify-between mb-1.5">
          <label className="text-[#1a1c2e] font-bold text-sm">Password</label>
          <button type="button" onClick={() => alert('Password reset functionality coming soon!')} className="text-[#5a66f1] font-semibold text-sm">Forgot password?</button>
        </div>
        <div className="w-full h-13 rounded-2xl bg-gray-50 border border-gray-100 flex items-center px-4 gap-3 mb-5 py-3">
          <span className="material-symbols-outlined shrink-0" style={{ fontSize: '20px', color: '#5a3fd6', fontVariationSettings: '"FILL" 1' }}>lock</span>
          <input type={showPass ? 'text' : 'password'} placeholder="••••••••" value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            className="bg-transparent outline-none border-none w-full text-base font-medium text-[#1a1c2e] placeholder-gray-400" />
          <button type="button" onClick={() => setShowPass(!showPass)} className="shrink-0">
            <span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#5a3fd6' }}>{showPass ? 'visibility_off' : 'visibility'}</span>
          </button>
        </div>
        <button onClick={handleSubmit} disabled={loading}
          className="w-full h-13 rounded-2xl text-white font-bold text-base flex items-center justify-center gap-2 active:scale-95 transition-all mb-4 py-3 disabled:opacity-50"
          style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 10px 25px -5px rgba(90,102,241,0.35)' }}>
          {loading ? '⏳ Signing in...' : <>Login <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>login</span></>}
        </button>
        <p className="text-center text-gray-500 text-sm font-medium mb-4">
          Don't have an account?{' '}
          <button onClick={onRegister} className="font-extrabold" style={{ color: '#3446e0' }}>Register</button>
        </p>
        <div className="flex items-center justify-center gap-4 mt-auto">
          {[{ icon: 'verified_user', label1: 'HIPAA', label2: 'Compliant' }, { icon: 'lock', label1: 'AES-256', label2: 'Encrypted' }].map((item, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="w-[1px] h-8 bg-gray-200"></span>}
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: '#eef0ff' }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '17px', color: '#3b55f0', fontVariationSettings: '"FILL" 1' }}>{item.icon}</span>
                </div>
                <div className="leading-tight">
                  <p className="text-xs font-semibold text-gray-600">{item.label1}</p>
                  <p className="text-xs font-semibold text-gray-600">{item.label2}</p>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════
// OTP SCREEN
// ═══════════════════════════════
// OTP SCREEN
// ═══════════════════════════════
function OTPScreen({ phone, onVerified }) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendCooldown, setResendCooldown] = useState(0);
  const [demoOtp, setDemoOtp] = useState('');
  const inputs = useRef([]);

  const generateOtp = () => {
    const newOtp = Math.floor(100000 + Math.random() * 900000).toString();
    setDemoOtp(newOtp);
  };

  useEffect(() => {
    generateOtp();
  }, []); // eslint-disable-line

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) inputs.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) inputs.current[index - 1]?.focus();
  };

  const handleVerify = async () => {
    const otpValue = otp.join('');
    if (otpValue.length !== 6) { setError('Please enter complete 6-digit OTP.'); return; }
    setLoading(true); setError('');
    if (otpValue === demoOtp) {
      setTimeout(() => { setLoading(false); onVerified(''); }, 800);
    } else {
      setTimeout(() => { setError('Invalid OTP. Please check the code shown above.'); setLoading(false); }, 800);
    }
  };

  const handleResend = () => {
    generateOtp();
    setOtp(['', '', '', '', '', '']);
    setError('');
    setResendCooldown(30);
    const interval = setInterval(() => {
      setResendCooldown(prev => { if (prev <= 1) { clearInterval(interval); return 0; } return prev - 1; });
    }, 1000);
  };

  return (
    <div className="w-full max-w-sm px-2">
      <div className="flex flex-col items-center text-center mb-6">
        <div className="w-16 h-16 bg-[#dae2ff] rounded-full flex items-center justify-center mb-4">
          <span className="material-symbols-outlined text-[#003d9b]" style={{ fontSize: '32px', fontVariationSettings: '"FILL" 1' }}>lock</span>
        </div>
        <h2 className="text-2xl font-black text-[#191c1e] mb-2">Verify Your Identity</h2>
        <p className="text-gray-500 text-sm leading-relaxed">
          Enter the 6-digit OTP for:<br />
          <span className="font-bold text-[#191c1e]">+91 •••••{phone?.slice(-3)}</span>
        </p>
      </div>
      {demoOtp && (
        <div className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-4 mb-5 text-center">
          <p className="text-xs text-yellow-600 font-bold uppercase tracking-wider mb-2">🔧 Demo Mode — Your OTP</p>
          <p className="text-4xl font-black text-yellow-700 tracking-[0.3em]">{demoOtp}</p>
          <p className="text-xs text-yellow-500 mt-2">In production this will be sent via SMS</p>
        </div>
      )}
      <div className="flex justify-center gap-2 mb-6">
        {otp.map((digit, index) => (
          <input key={index} ref={el => inputs.current[index] = el}
            type="text" maxLength={1} value={digit}
            onChange={e => handleChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(index, e)}
            style={{ width: '44px', height: '44px' }}
            className="text-center text-lg font-black border-2 border-gray-200 rounded-xl bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b] transition-all" />
        ))}
      </div>
      {error && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm mb-4">{error}</div>}
      <button onClick={handleVerify} disabled={loading}
        className="w-full h-14 bg-[#003d9b] text-white font-bold rounded-2xl flex items-center justify-center gap-2 active:scale-95 transition-all disabled:opacity-50 mb-4"
        style={{ boxShadow: '0 8px 25px rgba(0,61,155,0.3)' }}>
        {loading ? '⏳ Verifying...' : 'Verify & Continue'}
      </button>
      <p className="text-center text-sm text-gray-500">
        Didn't receive the code?{" "}
        <button onClick={handleResend} disabled={resendCooldown > 0} className="text-[#003d9b] font-bold disabled:text-gray-400">
          {resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend OTP'}
        </button>
      </p>
    </div>
  );
}

// ═══════════════════════════════
// PATIENT SUCCESS
// ═══════════════════════════════
function PatientSuccessScreen({ uid, onLogin }) {
  const [copied, setCopied] = useState(false);
  const copyUID = () => { navigator.clipboard.writeText(uid); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-8">
        <div className="w-full max-w-sm bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center">
          <div className="flex flex-col items-center gap-1 mb-6">
            <MHJLogo size={48} />
            <span className="font-extrabold text-lg" style={{
              background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 100%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
            }}>MyHealth Journal</span>
          </div>
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="material-symbols-outlined text-green-600" style={{ fontSize: '56px', fontVariationSettings: '"FILL" 1' }}>check_circle</span>
          </div>
          <div className="inline-block px-4 py-1.5 bg-gray-100 rounded-full mb-3">
            <p className="text-xs font-bold text-[#191c1e]">Your MyHealth Journal ID has been created</p>
          </div>
          <p className="text-gray-500 text-sm mb-6">Welcome to a more secure and connected health journey.</p>
          <div className="bg-gray-50 border-2 border-dashed border-[#003d9b]/20 rounded-xl p-4 mb-4 relative">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Patient UID</p>
            <p className="text-base font-black text-[#003d9b] select-all break-all">{uid || 'MHJ-2024-XXXX'}</p>
            <button onClick={copyUID} className="absolute top-3 right-3 p-1.5 hover:bg-white rounded-lg transition-colors">
              <span className="material-symbols-outlined text-[#003d9b]" style={{ fontSize: '18px' }}>{copied ? 'check' : 'content_copy'}</span>
            </button>
          </div>
          <div className="flex items-start gap-2 text-left mb-6">
            <span className="material-symbols-outlined text-[#003d9b] shrink-0 mt-0.5" style={{ fontSize: '18px' }}>info</span>
            <p className="text-xs text-gray-500 leading-relaxed">
              <strong>Save this ID</strong> — hospitals and labs will use it to upload your reports directly to your journal.
            </p>
          </div>
          <button onClick={onLogin}
            className="w-full h-14 text-white font-bold rounded-2xl active:scale-95 transition-all mb-3"
            style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,102,241,0.3)' }}>
            Go to Login
          </button>
        </div>
        <p className="text-gray-400 text-xs mt-4 text-center">A confirmation has been sent to your registered number.</p>
      </div>
    </div>
  );
}

// ═══════════════════════════════
// PENDING VERIFICATION
// ═══════════════════════════════
function PendingVerificationScreen({ role, onLogin }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fb]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-8">
        <div className="w-full max-w-sm bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center">
          <div className="flex flex-col items-center gap-1 mb-4">
            <MHJLogo size={48} />
            <span className="font-extrabold text-lg" style={{
              background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 100%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
            }}>MyHealth Journal</span>
          </div>
          <div className="w-20 h-20 bg-green-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="material-symbols-outlined text-green-600" style={{ fontSize: '48px', fontVariationSettings: '"FILL" 1' }}>check_circle</span>
          </div>
          <h2 className="text-xl font-black text-[#191c1e] mb-2">Registration Submitted</h2>
          <div className="inline-block px-4 py-1.5 bg-gray-100 rounded-full mb-4">
            <p className="text-xs font-bold text-[#191c1e]">Your credentials have been received</p>
          </div>
          <div className="bg-[#f8f9fb] border border-[#003d9b]/10 rounded-xl p-4 mb-4 text-left">
            <p className="text-sm text-gray-500 leading-relaxed">
              Your {role} registration has been submitted. Our team will verify your details and you will receive an <strong>email notification</strong> once your account is approved. This usually takes <strong>30 minutes</strong>.
            </p>
          </div>
          <div className="flex items-center justify-center gap-2 mb-6">
            <span className="material-symbols-outlined text-gray-400" style={{ fontSize: '16px' }}>schedule</span>
            <p className="text-xs text-gray-400">Verification usually takes 30 minutes.</p>
          </div>
          <button onClick={onLogin}
            className="w-full h-14 text-white font-bold rounded-2xl active:scale-95 transition-all"
            style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,102,241,0.3)' }}>
            Go to Login
          </button>
        </div>
        <p className="text-gray-400 text-xs mt-4 text-center">A confirmation will be sent to your registered email.</p>
      </div>
    </div>
  );
}

// ═══════════════════════════════
// PATIENT REGISTRATION FORM
// ═══════════════════════════════
function PatientRegForm({ onOTP, onSignIn, googleUser }) {
  const [form, setForm] = useState({ name: googleUser?.name || '', email: googleUser?.email || '', phone: '', aadhaar: '', dob: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.aadhaar.length !== 12) { setError('Aadhaar number must be 12 digits.'); return; }
    if (form.password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true); setError('');
    try {
      const formData = new FormData();
      formData.append('Name', form.name);
      formData.append('Phone', form.phone);
      formData.append('Password', form.password);
      formData.append('Role', 'patient');
      formData.append('AadhaarLast4', form.aadhaar.slice(-4));
      formData.append('DateOfBirth', form.dob);
      formData.append('Email', form.email || googleUser?.email || '');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Auth/register`, { method: 'POST', body: formData });
      const data = await response.json();
      if (response.ok) onOTP(form.phone);
      else setError(data.message || 'Registration failed.');
    } catch { setError('Cannot connect to server.'); }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {googleUser && <div className="bg-green-50 border border-green-200 rounded-xl p-3 flex items-center gap-2"><span className="material-symbols-outlined text-green-600" style={{ fontSize: '18px' }}>check_circle</span><p className="text-xs text-green-700 font-semibold">Connected with Google — some fields pre-filled!</p></div>}
      {error && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">{error}</div>}
      <div>
        <label className="block text-sm font-semibold text-[#191c1e] mb-1">Full Name <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">As per Aadhaar card</p>
        <input type="text" placeholder="John Doe" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
          className={`w-full px-4 py-3 border rounded-xl text-sm text-[#191c1e] focus:outline-none focus:border-[#003d9b] ${googleUser?.name ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'}`} />
      </div>
      {googleUser?.email ? (
        <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Email</label>
          <input type="email" value={googleUser.email} disabled className="w-full px-4 py-3 border border-green-200 rounded-xl text-sm bg-green-50 text-gray-500" /></div>
      ) : (
        <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Email Address <span className="text-red-500">*</span></label>
          <p className="text-xs text-gray-400 mb-1.5">Used for Google login and notifications</p>
          <input type="email" placeholder="john@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div>
      )}
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Phone Number <span className="text-red-500">*</span></label>
        <div className="relative"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-semibold">+91</span>
          <input type="tel" placeholder="98765 43210" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
            className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1">Aadhaar Number <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">12 digits — last 4 digits will be auto extracted</p>
        <input type="text" placeholder="000000000000" maxLength={12} value={form.aadhaar}
          onChange={e => setForm({ ...form, aadhaar: e.target.value.replace(/\D/g, '') })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" />
        <div className="flex items-center justify-between mt-1">
          <p className="text-xs text-gray-400">{form.aadhaar.length}/12 digits</p>
          {form.aadhaar.length === 12 && <p className="text-xs text-green-600 font-semibold">✅ Last 4: {form.aadhaar.slice(-4)}</p>}
        </div></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Date of Birth <span className="text-red-500">*</span></label>
        <input type="date" value={form.dob} onChange={e => setForm({ ...form, dob: e.target.value })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1">Password <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">Minimum 8 characters</p>
        <div className="relative">
          <input type={showPass ? 'text' : 'password'} placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
            className="w-full px-4 pr-12 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" />
          <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>{showPass ? 'visibility_off' : 'visibility'}</span>
          </button></div></div>
      <div className="flex items-start gap-3 pt-1">
        <input type="checkbox" className="mt-0.5 w-4 h-4 text-[#003d9b] rounded border-gray-300" />
        <p className="text-xs text-gray-500 leading-relaxed">I agree to the <button type="button" onClick={() => alert('Privacy policy terms')} className="text-[#003d9b] font-semibold underline">Privacy Policy</button> and authorize medical data sharing.</p>
      </div>
      <button type="submit" disabled={loading}
        className="w-full h-14 text-white font-bold rounded-2xl flex items-center justify-center gap-2 active:scale-95 transition-all disabled:opacity-50"
        style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,102,241,0.3)' }}>
        {loading ? '⏳ Creating...' : <>Verify Aadhaar & Send OTP <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>arrow_forward</span></>}
      </button>
      <p className="text-center text-sm text-gray-500 pb-4">Already have an account?
        <button type="button" onClick={onSignIn} className="text-[#003d9b] font-bold ml-1">Sign In</button></p>
    </form>
  );
}

// ═══════════════════════════════
// DOCTOR REGISTRATION FORM
// ═══════════════════════════════
function DoctorRegForm({ onSubmitted, onSignIn, googleUser }) {
  const [form, setForm] = useState({ name: googleUser?.name || '', email: googleUser?.email || '', phone: '', specialization: '', nmcNumber: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [certFile, setCertFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (!certFile) { setError('Please upload your NMC Certificate.'); return; }
    setLoading(true); setError('');
    try {
      const formData = new FormData();
      formData.append('Name', form.name); formData.append('Phone', form.phone);
      formData.append('Password', form.password); formData.append('Role', 'doctor');
      formData.append('Specialization', form.specialization); formData.append('NmcNumber', form.nmcNumber);
      formData.append('Certificate', certFile); formData.append('Email', form.email || googleUser?.email || '');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Auth/register`, { method: 'POST', body: formData });
      const data = await response.json();
      if (response.ok) onSubmitted();
      else setError(data.message || 'Registration failed.');
    } catch { setError('Cannot connect to server.'); }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {googleUser && <div className="bg-green-50 border border-green-200 rounded-xl p-3 flex items-center gap-2"><span className="material-symbols-outlined text-green-600" style={{ fontSize: '18px' }}>check_circle</span><p className="text-xs text-green-700 font-semibold">Connected with Google — some fields pre-filled!</p></div>}
      {error && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">{error}</div>}
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1">Full Name <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">As per NMC certificate</p>
        <input type="text" placeholder="Dr. John Doe" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
          className={`w-full px-4 py-3 border rounded-xl text-sm text-[#191c1e] focus:outline-none focus:border-[#003d9b] ${googleUser?.name ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'}`} /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Email Address <span className="text-red-500">*</span></label>
        <input type="email" placeholder="doctor@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
          disabled={!!googleUser?.email}
          className={`w-full px-4 py-3 border rounded-xl text-sm text-[#191c1e] focus:outline-none focus:border-[#003d9b] ${googleUser?.email ? 'bg-green-50 border-green-200 text-gray-500' : 'bg-white border-gray-200'}`} /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Phone Number <span className="text-red-500">*</span></label>
        <div className="relative"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-semibold">+91</span>
          <input type="tel" placeholder="98765 43210" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
            className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Specialization <span className="text-red-500">*</span></label>
        <select value={form.specialization} onChange={e => setForm({ ...form, specialization: e.target.value })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]">
          <option value="">Select specialization</option>
          {['Cardiology','Neurology','Pediatrics','Dermatology','General Physician','Endocrinology','Orthopedics','General Surgery','Psychiatry'].map(s => <option key={s}>{s}</option>)}
        </select></div>
      <div><div className="flex justify-between items-center mb-1">
          <label className="block text-sm font-semibold text-[#191c1e]">NMC Registration Number <span className="text-red-500">*</span></label>
          <a href="https://en.wikipedia.org/wiki/National_Medical_Commission" target="_blank" rel="noopener noreferrer" className="text-xs text-[#003d9b] font-bold flex items-center gap-0.5">What is NMC?<span className="material-symbols-outlined" style={{ fontSize: '12px' }}>open_in_new</span></a></div>
        <input type="text" placeholder="NMC-XXXX-XXXX" value={form.nmcNumber} onChange={e => setForm({ ...form, nmcNumber: e.target.value })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Upload NMC Certificate <span className="text-red-500">*</span></label>
        <label className="border-2 border-dashed border-gray-200 rounded-xl p-5 flex flex-col items-center justify-center hover:border-[#003d9b] hover:bg-[#003d9b]/5 transition-all cursor-pointer">
          <span className="material-symbols-outlined text-gray-400 mb-2" style={{ fontSize: '28px' }}>cloud_upload</span>
          <p className="text-sm font-semibold text-[#191c1e]">{certFile ? `✅ ${certFile.name}` : 'Upload Certificate'}</p>
          <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG (Max 10MB)</p>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setCertFile(e.target.files[0])} className="hidden" /></label></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1">Password <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">Minimum 8 characters</p>
        <div className="relative">
          <input type={showPass ? 'text' : 'password'} placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
            className="w-full px-4 pr-12 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" />
          <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>{showPass ? 'visibility_off' : 'visibility'}</span></button></div></div>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 flex gap-2">
        <span className="material-symbols-outlined text-[#003d9b] shrink-0" style={{ fontSize: '18px' }}>info</span>
        <p className="text-xs text-[#003d9b]">Your account will be reviewed by admin before approval. You'll be notified via email.</p></div>
      <div className="flex items-start gap-3">
        <input type="checkbox" className="mt-0.5 w-4 h-4 text-[#003d9b] rounded border-gray-300" />
        <p className="text-xs text-gray-500 leading-relaxed">I agree to the <button type="button" onClick={() => alert('Privacy policy terms')} className="text-[#003d9b] font-semibold underline">Privacy Policy</button> and professional conduct terms.</p></div>
      <button type="submit" disabled={loading}
        className="w-full h-14 text-white font-bold rounded-2xl flex items-center justify-center gap-2 active:scale-95 transition-all disabled:opacity-50"
        style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,102,241,0.3)' }}>
        {loading ? '⏳ Submitting...' : <>Submit for Verification <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>arrow_forward</span></>}
      </button>
      <p className="text-center text-sm text-gray-500 pb-4">Already have an account?
        <button type="button" onClick={onSignIn} className="text-[#003d9b] font-bold ml-1">Sign In</button></p>
    </form>
  );
}

// ═══════════════════════════════
// PROVIDER REGISTRATION FORM
// ═══════════════════════════════
function ProviderRegForm({ onSubmitted, onSignIn, googleUser }) {
  const [form, setForm] = useState({ name: googleUser?.name || '', email: googleUser?.email || '', phone: '', providerType: '', regNumber: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [certFile, setCertFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true); setError('');
    try {
      const formData = new FormData();
      formData.append('Name', form.name); formData.append('Phone', form.phone);
      formData.append('Password', form.password); formData.append('Role', 'provider');
      formData.append('ProviderRole', form.providerType); formData.append('RegistrationNumber', form.regNumber);
      if (certFile) formData.append('Document', certFile);
      formData.append('Email', form.email || googleUser?.email || '');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Auth/register`, { method: 'POST', body: formData });
      const data = await response.json();
      if (response.ok) onSubmitted();
      else setError(data.message || 'Registration failed.');
    } catch { setError('Cannot connect to server.'); }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {googleUser && <div className="bg-green-50 border border-green-200 rounded-xl p-3 flex items-center gap-2"><span className="material-symbols-outlined text-green-600" style={{ fontSize: '18px' }}>check_circle</span><p className="text-xs text-green-700 font-semibold">Connected with Google — some fields pre-filled!</p></div>}
      {error && <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">{error}</div>}
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Full Name <span className="text-red-500">*</span></label>
        <input type="text" placeholder="Organization or contact name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
          className={`w-full px-4 py-3 border rounded-xl text-sm text-[#191c1e] focus:outline-none focus:border-[#003d9b] ${googleUser?.name ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'}`} /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Email Address <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">Used for Google login in future</p>
        <input type="email" placeholder="provider@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
          disabled={!!googleUser?.email}
          className={`w-full px-4 py-3 border rounded-xl text-sm text-[#191c1e] focus:outline-none focus:border-[#003d9b] ${googleUser?.email ? 'bg-green-50 border-green-200 text-gray-500' : 'bg-[#191c1e] focus:outline-none focus:border-[#003d9b]'}`} /></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Phone Number <span className="text-red-500">*</span></label>
        <div className="relative"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-semibold">+91</span>
          <input type="tel" placeholder="98765 43210" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
            className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Provider Type <span className="text-red-500">*</span></label>
        <select value={form.providerType} onChange={e => setForm({ ...form, providerType: e.target.value })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]">
          <option value="">Select provider type</option>
          {['Diagnostic Lab','Hospital','Clinic','Radiology Center','Pharmacy'].map(t => <option key={t}>{t}</option>)}
        </select></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1.5">Registration Number <span className="text-red-500">*</span></label>
        <input type="text" placeholder="Organization registration number" value={form.regNumber} onChange={e => setForm({ ...form, regNumber: e.target.value })}
          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" /></div>
      <div><div className="flex justify-between items-center mb-1.5">
          <label className="block text-sm font-semibold text-[#191c1e]">Registration Certificate</label>
          <a href="https://en.wikipedia.org/wiki/National_Accreditation_Board_for_Testing_and_Calibration_Laboratories" target="_blank" rel="noopener noreferrer" className="text-xs text-[#003d9b] font-bold flex items-center gap-0.5">What is this?<span className="material-symbols-outlined" style={{ fontSize: '12px' }}>open_in_new</span></a></div>
        <label className="border-2 border-dashed border-gray-200 rounded-xl p-5 flex flex-col items-center justify-center hover:border-[#003d9b] hover:bg-[#003d9b]/5 transition-all cursor-pointer">
          <span className="material-symbols-outlined text-gray-400 mb-2" style={{ fontSize: '28px' }}>cloud_upload</span>
          <p className="text-sm font-semibold text-[#191c1e]">{certFile ? `✅ ${certFile.name}` : 'Upload Certificate'}</p>
          <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG (Max 10MB)</p>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setCertFile(e.target.files[0])} className="hidden" /></label></div>
      <div><label className="block text-sm font-semibold text-[#191c1e] mb-1">Password <span className="text-red-500">*</span></label>
        <p className="text-xs text-gray-400 mb-1.5">Minimum 8 characters</p>
        <div className="relative">
          <input type={showPass ? 'text' : 'password'} placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
            className="w-full px-4 pr-12 py-3 border border-gray-200 rounded-xl text-sm bg-white text-[#191c1e] focus:outline-none focus:border-[#003d9b]" />
          <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>{showPass ? 'visibility_off' : 'visibility'}</span></button></div></div>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 flex gap-2">
        <span className="material-symbols-outlined text-[#003d9b] shrink-0" style={{ fontSize: '18px' }}>info</span>
        <p className="text-xs text-[#003d9b]">Your provider account will be verified by our team before access is granted. You'll be notified via email.</p></div>
      <div className="flex items-start gap-3">
        <input type="checkbox" className="mt-0.5 w-4 h-4 text-[#003d9b] rounded border-gray-300" />
        <p className="text-xs text-gray-500 leading-relaxed">I agree to the <button type="button" onClick={() => alert('Privacy policy terms')} className="text-[#003d9b] font-semibold underline">Privacy Policy</button> and provider terms.</p></div>
      <button type="submit" disabled={loading}
        className="w-full h-14 text-white font-bold rounded-2xl flex items-center justify-center gap-2 active:scale-95 transition-all disabled:opacity-50"
        style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #5a66f1 100%)', boxShadow: '0 8px 25px rgba(90,102,241,0.3)' }}>
        {loading ? '⏳ Submitting...' : <>Submit for Verification <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>arrow_forward</span></>}
      </button>
      <p className="text-center text-sm text-gray-500 pb-4">Already have an account?
        <button type="button" onClick={onSignIn} className="text-[#003d9b] font-bold ml-1">Sign In</button></p>
    </form>
  );
}